
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Dialog, IconButton, DialogTitle, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import '../../contactos/modalContacts.css'

import { useCatalog } from '../../../hooks/useCatalog'
import { sortInitialItemPptosGastos } from '../../../helpers/items'
import { initAddInitialServices } from '../../../redux/actions/pptosGastos'

export const DialogInitialService = ({ open, setOpen }) => {

    const dispatch = useDispatch()

    const { catalogGroup, initLoadCatalogGroup } = useCatalog()
    const [selected, setSelected] = useState([])

    const handleSelected = (e, item) => {
        const { checked } = e.target

        if (checked) {
            setSelected([...selected, item])
        } else {
            const newSelected = selected.filter(it => it.id !== item.id)
            setSelected(newSelected)
        }
    }

    const handleAdd = async () => {
        const orderedItems = await sortInitialItemPptosGastos(selected, catalogGroup)
        dispatch(initAddInitialServices(orderedItems))
        setOpen(false)
    }

    useEffect(() => {
        initLoadCatalogGroup({ tipo: 'compra' })
    }, [initLoadCatalogGroup])

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                Servicios para agregar
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <div className="table-responsive">

                    <div className='d-flex justify-content-between align-items-end'>
                        <button
                            className='btn p-btn-primary mt-3'
                            style={{ width: '200px' }}
                            disabled={selected.length > 0 ? false : true}
                            onClick={handleAdd}
                        >
                            <i className="bi bi-plus"></i> Agregar seleccionados
                        </button>
                        <span>{`${selected.length} seleccionados`}</span>
                    </div>

                    <table className="table mt-3 table-borderless">
                        <thead className='p-thead-global'>
                            <tr className="p-tr-titles-global">
                                <th className='text-start'>Servicio</th>
                                <th className='text-start'>Categoría</th>
                            </tr>
                        </thead>
                        <tbody>
                            {catalogGroup?.length > 0 && catalogGroup?.map(it => (
                                <>
                                    {it.items.map(its => (
                                        <tr key={its.id} style={{ textTransform: 'capitalize' }}>
                                            <td className='text-start'>
                                                <div className='align-items-center ms-3'>
                                                    <input
                                                        type="checkbox"
                                                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                        onChange={(e) => handleSelected(e, its)}
                                                    />
                                                    <span className='ms-2'>{its.nombre?.toLowerCase() || '---'}</span>
                                                </div>
                                            </td>
                                            <td>{it.nombre?.toLowerCase() || '---'}</td>
                                        </tr>
                                    ))}

                                </>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            </DialogContent>

        </Dialog>
    )
}